const selectShiftFromState = state => state.shift;

export const selectShiftDetailFromState = state =>
  selectShiftFromState(state).shiftDetail;
export const selectShiftsListFromState = state =>
  selectShiftFromState(state).list;
export const selectShiftsListLoadingFromState = state =>
  selectShiftFromState(state).loading;

export const selectShiftRidersListFromState = state =>
  selectShiftFromState(state).shiftRiders.map(rider => ({
    ...rider,
    isDisabled: !!rider.id
  }));
